module.exports = __webpack_public_path__ + "img/thumb-north-park-university@2x.16204c36.png";